export default __webpack_public_path__ + "static/media/arcanecrystals.528ffcaf.png";